document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('.pickup-available');
    if (!trigger) return;
    
    e.preventDefault();
    
    const variantId = trigger.dataset.variantId;
    if (!variantId) {
      console.warn('No variant ID found');
      return;
    }
    // Open modal first
    openPickupModal();
    const modalContent = document.querySelector('.pickup-modal__content');
    if (modalContent) {
      modalContent.innerHTML = '<div class="loading-overlay">Loading pickup availability...</div>';
    }
    // Fetch pickup availability using the same structure as pickup-availability.js
    fetch(`/variants/${variantId}/?section_id=pickup-availability`)
      .then(response => response.text())
      .then(text => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('.shopify-section');

        const drawer = sectionInnerHTML.querySelector('.pickup-availability-list');
        if (drawer) {
          const drawerContent = drawer.cloneNode(true);  
          // Remove any existing event listeners and convert to static HTML
          const drawerHtml = drawerContent.innerHTML;
          modalContent.innerHTML = `
            <ul class="pickup-availability-drawer-copy">
              ${drawerHtml}
            </ul>
          `;
        } else {
          // If no drawer found, show preview or error
          const preview = sectionInnerHTML.querySelector('pickup-availability-preview');
          if (preview) {
            modalContent.innerHTML = preview.outerHTML;
          } else {
            modalContent.innerHTML = '<p>No pickup locations available for this item.</p>';
          }
        }
      })
      .catch(error => {
        console.error('Error fetching pickup availability:', error);
        if (modalContent) {
          modalContent.innerHTML = `
            <div class="pickup-availability-error">
              <p>Error loading pickup availability.</p>
              <button class="button button--secondary" onclick="window.location.reload()">Try Again</button>
            </div>
          `;
        }
      });
  });
  // Function to open modal
  function openPickupModal() {
    const modal = document.querySelector('.pickup-modal');
    const overlay = document.querySelector('.pickup-modal-overlay');
    
    if (!modal || !overlay) {
      console.error('Modal or overlay elements not found');
      return;
    }
    modal.style.display = 'block';
    overlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }
  // Function to close modal
  function closePickupModal() {
    const modal = document.querySelector('.pickup-modal');
    const overlay = document.querySelector('.pickup-modal-overlay');
    
    if (modal) modal.style.display = 'none';
    if (overlay) overlay.style.display = 'none';
    document.body.style.overflow = 'auto';
  }
  
  // Handle modal close events
  document.addEventListener('click', function(e) {
    if (e.target.closest('.pickup-modal__close') || 
        e.target.classList.contains('pickup-modal-overlay')) {
      closePickupModal();
    }
  });
  
  // Close modal with Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const modal = document.querySelector('.pickup-modal');
      if (modal && modal.style.display === 'block') {
        closePickupModal();
      }
    }
  });
});